import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';
import { withTranslation } from 'react-i18next';

import { Row, Col, Input } from 'antd';

import UrlParamSync from '../../../../../../../UrlParamSync';

import filterActions from '../../../../../../../../actions/filterActions';

import styles from './viewHeader.less';

class Search extends Component {
  static propTypes = {
    viewId: PropTypes.string,
    sceneId: PropTypes.string,
  };

  constructor(props) {
    super(props);
    const searchText = props.scene ? props.scene.get('searchText') : '';

    this.state = {
      focused: false,
      searchText,
      prevSearchText: searchText,
    };
  }

  handleInputFocus = (e) => {
    this.setState({ focused: true });
  };

  handleInputBlur = () => {
    this.setState({ focused: false });
  };

  onChangeSearch(text) {
    this.setState(
      {
        searchText: text,
      },
      () => {
        filterActions.searchByText(
          this.props.sceneId,
          text,
          {
            viewId: this.props.viewId,
          },
          this.props.viewMode,
        );
      },
    );
  }

  onSearchChange = (e) => {
    const text = e.target.value;
    this.onChangeSearch(text);
  };

  onSearchChangeFromURL = (text) => {
    this.onChangeSearch(text);
  };

  render() {
    const text = this.state.searchText;
    const hasText = text || text === '0';
    const collapsed = !hasText && !this.state.focused;

    return (
      <Col
        className={cn(styles.quickSearchContainer, this.props.className, {
          [styles.collapsed]: collapsed,
        })}
      >
        <Input
          allowClear
          placeholder={
            collapsed ? this.props.t('catalogData.quickSearch') : this.props.t('catalogData.expandedQuickSearch')
          }
          className={styles.quickSearchInput}
          value={text}
          onChange={this.onSearchChange}
          onFocus={this.handleInputFocus}
          onBlur={this.handleInputBlur}
        />
        <UrlParamSync name="search" value={text} onChange={this.onSearchChangeFromURL} />
      </Col>
    );
  }
}

export default withTranslation()(Search);
